<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model" *transloco="let tr; prefix: 'productDefinitions'; scope: 'product-definitions'">
  <form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.brandId')}}</nz-form-label>
          <nz-form-control>
            <hx-brand-select formControlName="brandId"></hx-brand-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.type')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select [enumType]="ProductInfoType" enumName="ProductInfoType"
                            formControlName="type"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="enabled">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1_2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1_2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.fullTitle')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="fullTitle"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.kind')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select [enumType]="KindType" enumName="KindType" formControlName="kind"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1"
           *ngIf="form.controls['brandId'].value && form.controls['type'].value && isNotMaterial">
        <nz-form-item>
          <nz-form-label [nzRequired]="isInventoryItems">{{tr('form.categoryId')}}</nz-form-label>
          <nz-form-control>
            <hx-product-category-select formControlName="categoryId" [brandId]="form.controls['brandId'].value" [preload]="true"></hx-product-category-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1"
           *ngFor="let fk of ['decored','globalForSale','cfOutputProduct','toCbInvoice','dynamicWeight','onlineSellable','purchasable','unlimited']">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.' + fk)}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group [formControlName]="fk">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label
            [nzRequired]="isInventoryItems">{{tr('form.weight')}}</nz-form-label>
          <nz-form-control>
            <nz-input-number formControlName="weight" [nzMin]="1" [nzStep]="1"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label
            [nzRequired]="isInventoryItems">{{tr('form.unitOfMeasureId')}}</nz-form-label>
          <nz-form-control>
            <hx-unit-measure-select formControlName="unitOfMeasureId"></hx-unit-measure-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.description')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit [type]="'markdown'" formControlName="description"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8" *ngIf="form.controls['brandId'].value">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label>{{tr('form.parentId')}}</nz-form-label>
          <nz-form-control>
            <hx-dictionary-select dictionaryKey="spendings" formControlName="spendCategoryCode"></hx-dictionary-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label
            [nzRequired]="isInventoryItems">{{tr('form.composition')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit [type]="'markdown'" formControlName="composition"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1_2">
        <nz-form-item>
          <nz-form-label>{{tr('form.ntin')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="ntin"/>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1_2">
        <nz-form-item>
          <nz-form-label>{{tr('form.gtin')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="gtin"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
